<div
    class="c-modal__overlay-container"
    *ngIf="createOverlay; else withoutOverlay"
>
    <div
        class="c-modal__backdrop c-modal__backdrop--dark c-modal__backdrop--showing"
        [@fadeOverlay]="animationState"
    >
        <div class="c-modal__global-overlay-wrapper">
            <div class="c-modal__overlay-pane">
                <div
                    class="c-modal__container"
                    [@slideModal]="animationState"
                    (@slideModal.done)="onAnimationEvent($event)"
                >
                    <ng-container
                        [ngTemplateOutlet]="contentTpl"
                    ></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #withoutOverlay>
    <div class="c-modal__container">
        <ng-container [ngTemplateOutlet]="contentTpl"></ng-container>
    </div>
</ng-template>
<ng-template #contentTpl>
    <ng-content></ng-content>
</ng-template>
